const $khttp = require('./khttp');
const moment = require('moment');
// 得到名字
String.prototype.getName = function( B_GetSuffixed ){
	var temp = this.toString( );
	temp = temp.substring( temp.lastIndexOf("/")+1 );
	if( B_GetSuffixed == false && temp.lastIndexOf(".") != -1 ){
		temp = temp.substring( 0,temp.lastIndexOf(".") );
	}
	return temp;
};
// 得到上级路径
String.prototype.getParent = function(){
	var temp = this.toString( );
	if( temp.lastIndexOf("/") == -1 ){
		return "";
	}
	var subIndex = temp.lastIndexOf("/");
	temp = temp.substring( 0,subIndex );
	return temp;
};
// 得到后缀
String.prototype.getSuffixed = function( B_HavePoint ){
	var temp = this.toString( ).getName( );
	if( temp.lastIndexOf(".") == -1 ){
		return "";
	}
	var subIndex = temp.lastIndexOf(".");
	if( B_HavePoint == false ){
		subIndex++;
	}
	temp = temp.substring( subIndex );
	return temp;
}
String.prototype.startWith=function(s){
	if(s==null||s==""||this.length==0||s.length>this.length)
		return false;
	if(this.substr(0,s.length)==s)
		return true;
	else
		return false;
	return true;
};
String.prototype.endWith=function(s){
	if(s==null||s==""||this.length==0||s.length>this.length)
		return false;
	if(this.substring(this.length-s.length)==s)
		return true;
	else
		return false;
	return true;
};
String.prototype.replaceAll  = function(s1, s2){
	var result='';
	var initStr = this;
	while(initStr.indexOf(s1)!=-1){
		k=initStr.indexOf(s1);
		initStr=initStr.replace(s1, s2);
		result += initStr.substr(0, k+s2.length);
		initStr=initStr.substr(k+s2.length);
	}
	result+=initStr;
	return result;
}
String.prototype.format = function() {
	let result = this.toString( );
	for (let i = 0; i < arguments.length ; i++) {
		let reg = new RegExp('\\{' + i + '\\}', 'gm');
		result = result.replace(reg, arguments[i]);
	}
	return result;
};
// 得到父级路径
String.prototype.getParent = function( ){
	let temp = this.toString(  );
	if( temp.indexOf("/") > -1 ){
		temp = temp.substring(0,temp.lastIndexOf("/"));
		temp = (temp == ""?"/":temp);
	}else{
		temp = temp.substring(0,temp.lastIndexOf("\\"));
		temp = (temp == ""?"\\":temp);
	}
	return temp;
};
Date.prototype.Format = function (fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
};
/*** 删除指定键值的数组 ***/
Array.prototype.deletes = function(val){
	var result;
	while(true){
		var idx = -1;
		this.forEach(function(value, index, arr){
			if(value==val){
				idx = index;
			}
		});
		//找不到跳出循环
		if(idx<0){
			break;
		}
		result = this.splice(idx, 1);
	}
	return result;
};

Array.prototype.delete = function(item,key){
	var result;
	while(true){
		var idx = -1;
		this.forEach(function(value, index, arr){
			if(value[key]==item[key]){
				idx = index;
			}
		});
		//找不到跳出循环
		if(idx<0){
			break;
		}

		result = this.splice(idx, 1);
	}
	return result;
};
Array.prototype.remove = function(val){
	var index = this.indexOf(val);
	if (index> -1){
		this.splice(index, 1);
	}
};
Array.prototype.jsonIndexOf = function(key,val){
	var idx = -1;
	for(var i = 0;i<this.length;i++){
		if(this[i][key]==val){
			idx = i;
			break;
		}
	}
	return idx;
};
Array.prototype.jsonRemove = function(key,val){
	var idx = -1;
	for(var i = 0;i<this.length;i++){
		if(this[i][key]==val){
			idx = i;
			break;
		}
	}
	if(idx>=0){
		this.splice(idx, 1);
	}
}
Array.prototype.jsonRest = function(key,val,newitem){
	var idx = -1;
	for(var i = 0;i<this.length;i++){
		if(this[i][key]==val){
			idx = i;
			break;
		}
	}
	if(idx>=0){
		this.splice(idx, 1, newitem);
	}
};
Array.prototype.jsonSwap = function(key,val,up){
	var idx = -1;
	for(var i = 0;i<this.length;i++){
		if(this[i][key]==val){
			idx = i;
			break;
		}
	}

	if(idx<=0 && up){
		return;
	}else if(!up && idx>=this.length){
		return;
	}else{
		this[idx] = this.splice(up?idx-1:idx+1, 1, this[idx])[0];
	}
};
Array.prototype.moveSwap = function(idx,up){
	if(idx<0){
		return;
	}
	if(idx<=0 && up){
		return;
	}else if(!up && idx>=(this.length-1)){
		return;
	}else{
		this[idx] = this.splice(up?idx-1:idx+1, 1, this[idx])[0];
	}
}
Array.prototype.indexSwap = function(srcIdx,tagIdx){
	if(srcIdx<0 || tagIdx<0 ){
		return;
	}
	if(srcIdx>=this.length || tagIdx>=this.length ){
		return;
	}
	this[srcIdx] = this.splice(tagIdx, 1, this[srcIdx])[0];
};
const Map = function Map(){
	var size = 0;
	var entry = new Object();
	this.put = function (key , value){
		if(!this.containsKey(key)){
			size ++ ;
		}
		entry[key] = value;
	}
	this.set = function (key , value){
		if(!this.containsKey(key)){
			size ++ ;
		}
		entry[key] = value;
	}
	this.get = function (key){
		return this.containsKey(key) ? entry[key] : null;
	}
	this.remove = function ( key ){
		if( this.containsKey(key) && ( delete entry[key] ) ){
			size --;
		}
	}
	this.containsKey = function ( key ){
		return (key in entry);
	}
	this.keys = function (){
		var keys = new Array();
		for(var prop in entry){
			keys.push(prop);
		}
		return keys;
	}
	this.values = function(){
		var values = new Array();
		for(var prop in entry){
			values.push(entry[prop]);
		}
		return values;
	}
	this.size = function (){
		return size;
	}
	this.clear = function (){
		size = 0;
		entry = new Object();
	}
}

const $kutil={	
	getTopWindow:function(){
		try{
			if( window.cacheTopWindow!=undefined ){
				return window.cacheTopWindow; //从缓存中查询
			}
		}catch(e){
			
		}
		try{
			var test = top.location.href;
			window.cacheTopWindow = top;
			return top;
		}catch(e){//进入跨域错误

		}
		/*** 跨域获取本项目的顶级window ****/
		var topWindow = window;
		while( true ){
			try{
				var test = topWindow.parent.href;//检查上级window是否已不是本域,非本域将抛出异常
				if(topWindow.parent==null || topWindow==topWindow.parent){//找不到或就是本身表示就是当前域的最顶级					
					break;
				}else{
					topWindow = topWindow.parent;
				}
			}catch(e){
				break;
			}
		}
		try{
			window.cacheTopWindow = topWindow; //缓存一个topWindow
		}catch(e){
			
		}
		return topWindow;
	},
	// 打开文件预览窗口
	openPreview:function(node,datahash,bothers,groupnodes, showProp){
		try{
			let isKClient = navigator.userAgent.indexOf('kabalaclient') > -1;
			if(isKClient){
				$kutil.openNewPagePreview(node,datahash);
			}else{
				$kutil.getTopWindow().openPreview(node,datahash,bothers,groupnodes, showProp);
			}
		}catch(e){			
			return;
		}
	},
    openSimplePreview:function(node, url){
        $kutil.getTopWindow().openPreview(node,"",[],[], null, url);
	},
	openNewPagePreview:function(node,datahash){
		try{
			let cnum = node.cnum;
			let url = '/kabala/view.html?cnum='+cnum;
			if (datahash) {
				url +='&hash='+datahash;
			}
			$kutil.getTopWindow().open(url);
		}catch(e){			
			return;
		}
	},
	openUserDialog:function(role,group,user,multi,rootid,defaultids,callback,grouproot){
		try{
			if($kutil.checkBrowser().Mobile){
				$kutil.getTopWindow().openUserDialog(role, group,user,multi,rootid,defaultids,function(datas){
					if( !datas || datas.length==0 ){
						callback(null);
					}else{
						let uids = [];
						for(let i = 0;i<datas.length;i++){		
							uids.push(datas[i].uid);	
						}
						callback(uids);
					}
				}, grouproot);
			}else{
				$kutil.getTopWindow().openUserDialog(role, group,user,multi,rootid,defaultids,callback,grouproot);
			}
		}catch(e){			
			return;
		}
	},
	openScopeUserDialog:function(role,group,user,multi,scope,defaultids,callback){
		try{
			if($kutil.checkBrowser().Mobile){
				$kutil.getTopWindow().openScopeUserDialog(role, group,user,multi,scope,defaultids,function(datas){
					if( !datas || datas.length==0 ){
						callback(null);
					}else{
						let uids = [];
						for(let i = 0;i<datas.length;i++){		
							uids.push(datas[i].uid);	
						}
						callback(uids);
					}
				});
			}else{
				$kutil.getTopWindow().openScopeUserDialog(role, group,user,multi,scope,defaultids,callback);
			}
		}catch(e){			
			return;
		}
	},
	/**
	 * 判断移动 or pc端，调用对应 Modal 打开方式
 	 * @param dir 文件夹
	 * @param file 文件
	 * @param multi 是否支持多选
	 * @param rootpath 根路径
	 * @param defaultpaths 默认路径
	 * @param callback 回调方法
	 */
	openFileDialog:function(dir,file,multi,rootpath,defaultpaths,callback,optional){
		try{
			
			if($kutil.checkBrowser().Mobile){
				//....
				$kutil.getTopWindow().openSpaceFileDialog(dir,file,multi,rootpath,defaultpaths,callback);
			}else{
				$kutil.getTopWindow().openFileDialog(dir,file,multi,rootpath,defaultpaths,callback,optional);
			}
		}catch(e){
			return;
		}
	},
	openFileUpload:function(savedpath,multi,callback,options){
		try{
			if($kutil.checkBrowser().Mobile){
				//....
				$kutil.getTopWindow().openFileDialog(savedpath,false,true,multi,"",null,callback);
			}else{
				$kutil.getTopWindow().openFileDialog(false,true,multi,"",null,callback, options);
			}
		}catch(e){
			//cross error;
			//$kcross.clientAskCross("$kutil.openFileDialog",[dir,file,multi,rootpath,defaultpaths,callback]);
			return;
		}
	},
	openDirDialog:function(root, dir, callback){
		try{
			$kutil.getTopWindow().openDirDialog(root, dir, callback);
		}catch(e){
			//cross error;
			//$kcross.clientAskCross("$kutil.openDirDialog",[root, dir, callback]);
			return;
		}
	},
	/**
	encodeURI:function(val){
			//不会被此方法编码的字符：! @ # $& * ( ) = : / ; ? + '
			服务器端java.net.URLEncoder.encode(s, "utf-8") 解码结果
			!=%21 @=%40 #=%23 $=%24 &=%26 *=* (=%28 )=%29 ==%3D :=%3A /=%2F ;=%3B ?=%3F +=%2B '=%27 "=%22 **/
			/*** JS encodeURI一次的结果
			!=! @=@ #=# $=$ &=& *=* (=( )=) === :=: /=/ ;=; ?=? +=+ '=' "=%22
		return encodeURIComponent(val).replace(/\//g,'%2F').replace(/\+/g,'%2B')
		.replace(/\'/g,'%27').replace(/\&/g,'%26').replace(/\=/g,'%3D').replace(/%20/g,'+')
		.replace(/\?/g,'%3F').replace(/\#/g,'%23').replace(/\:/g,'%3A').replace(/\,/g,'%2C').replace(/\@/g,'%40').replace(/\$/g,'%24').replace(/\(/g,'%28').replace(/\)/g,'%29')
		.replace(/\;/g,'%3B').replace(/\"/g,'%22').replace(/\!/g,'%21')
	},**/
	regExp:{
		CHINESE_CHARACTER: /[\u4e00-\u9fa5]/,
		NAME: /^[a-zA-Z\u4e00-\u9fa5]+$/,
		HTTP_ALL: /http(s?):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\’:+!]*([^<>\"\"])*/g,
		HTTP_STRICT: /((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:\/~\+#]*[\w\-\@?^=%&amp;\/~\+#])?|www+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:\/~\+#]*[\w\-\@?^=%&amp;\/~\+#])?)/gi,
		HTTP: /^http(s?):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\’:+!]*([^<>\"\"])*$/,
		DOMAIN : /^(http|https|ws|wss):\/\/([^/:]+)(:\d*)?\//,
		EMAIL: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
		NUMBER_AND_LETTER: /^([A-Z]|[a-z]|[\d])*$/,
		POSITIVE_NUMBER: /^[1-9]\d*$/,
		NON_NEGATIVE_NUMBER: /^(0|[1-9]\d*)$/,
		IP: /^((1?\d?\d|(2([0-4]\d|5[0-5])))\.){3}(1?\d?\d|(2([0-4]\d|5[0-5])))$/,
		URL: /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/,
		PHONE: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$|^(13|14|15|17|18)[0-9]{9}$/,
		TELEPHONE: /^(13|14|15|17|18|19)[0-9]{9}$/,
		QQ: /^\d{1,10}$/,
		DATE: /^((?!0000)[0-9]{4}-((0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-8])|(0[13-9]|1[0-2])-(29|30)|(0[13578]|1[02])-31)|([0-9]{2}(0[48]|[2468][048]|[13579][26])|(0[48]|[2468][048]|[13579][26])00)-02-29)$/,
		POUND_TOPIC: /^#([^\/|\\|\:|\*|\?|\"|<|>|\|]+?)#/,
		AT: /(@[a-zA-Z0-9_\u4e00-\u9fa5（）()]+)(\W|$)/gi,
		DIR_NAME: /[\\/:*?\"<>|]/,
		EmplName: /[\\\/:*?\"'<>\{};#!|]/,
		PWD : /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))^.{8,32}$/
	},
	/**
	 * 数组排序
	 * arr可以是字符数组或者对象数组
	 */
	sortArray: function(arr, name, desc ){
		var low = 0;
		var high= arr.length-1;
		var tmp,j;
		while (low < high) {
			var pos1 = 0, pos2=0;
			for(var i= low; i < high; ++i){
				var a= name?(arr[i][name]==undefined?"":arr[i][name]):arr[i];
				var b= name?(arr[i+1][name]==undefined?"":arr[i+1][name]):arr[i+1];
				if ( a > b) {
					tmp = arr[i]; arr[i]=arr[i+1];arr[i+1]=tmp;
					pos1 = i ;
				}
			}

			high = pos1;
			for(var j=high; j>low; --j){
				var a= name?(arr[j][name]==undefined?"":arr[j][name]):arr[j];
				var b= name?(arr[j-1][name]==undefined?"":arr[j-1][name]):arr[j-1];
				if (a < b) {
					tmp = arr[j]; arr[j]=arr[j-1];arr[j-1]=tmp;
					pos2 = j;
				}
			}
			low = pos2;
		}
		return desc?arr.reverse( ):arr;
	},
	random:function(len){
		let _chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
		len = len || 32
		let maxPos = _chars.length
		let str = ''
		for (let i = 0; i < len; i++) {
			str += _chars.charAt(Math.floor(Math.random() * maxPos))
		}
		return str
	},
	// 获取url查询参数, 返回map结构
	getQueryParams: function(url){
		let obj = {}
		try{
			let str = url
			if(url.indexOf("#") > -1){
				str = url.substring(0, url.indexOf("#"));
			}
			let params = str.split("?")[1].split("&");
			for (let i = 0; i < params.length; i++) {
				let param = params[i].split("=");
				obj[param[0]] = param[1]
			}
		}catch(err){}
		return obj;
	},
	getQueryParam:function(url,name){
		// (^|&)query=([^&]*)(&|$)
		var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		var r = url.toString().substr(1).match(reg);
		if(r!=null)
			return  decodeURIComponent(r[2]);
		return null;
	},
	randomColor:function(index){
		// var notecolor = ['#008FEC','#F5BD70','#2AC175','#7CB5EC','#f56a00','#74AAE3','#8BBE79','#91C7AE','#D48265','#61A0A8','#f56a00','#CFE3FE', '#7265e6', '#ffbf00', '#00a2ae','#D35400','#C0392B','#16A085','#27AE60','#3498DB','#8E44AD','#34495E','#2F4554'];
		var notecolor = ['#889EFE','#3396F8','#51A6E2','#4ED2C3','#f56a00','#84D057','#FEA003','#F87E06','#F15757'];
		return notecolor[index % notecolor.length];
	},
	printCallStack:function(){
		try{
			var i = 0;
			var fun = arguments.callee;
			do{
				fun = fun.arguments.callee.caller;
				console.log(++i + ': ' + (fun!=null?fun:"") );
			} while (fun);
		}catch(e){
			console.error(e);
		}
	},
	/**
	 * 获取文件对应类型的icon图标路径
	 * @param path 当前文件的路径 解析出type
	 * @param size 图片尺寸
	 * @returns {string} 图片本地路径
	 */
	iconUrl:function(path,size){
		var defaultSize = "";
		if(size==20 || size==64 || size==96){
			defaultSize="_"+size;
		}
		var suppertIcon = "ai,apk,asp,aspx,avo,bmp,catdrawing,catpart,catproduct,cdr,cpp,cs,css,csv,doc,docx,dps,dpt,dwg,eio,eml,et,ett,exb,exe,file,flv,gif,h,html,java,jpeg,jpg,js,jsp,md,mht,mhtl,mhtml,mid,mp3,mp4,mpeg,msi,odp,ods,odt,pdf,png,pps,ppt,pptx,prt,psd,py,rar,rm,rmvb,rtf,sld,sldprt,swf,tif,tiff,txt,url,wav,wma,wmv,wps,wpt,xls,xlsx,zip";
		if(path){
			var icons = suppertIcon.split(",");
			var type = path.substring(path.lastIndexOf(".")+1).toLowerCase();
			for(var i=0;i<icons.length;i++){
				if(icons[i] == type ){
					return "/kabala/images/file_icons"+defaultSize+"/"+type+".png";
				}
			}
		}
		return "/kabala/images/file_icons"+defaultSize+"/file.png";
	},
	iconUrl2:function(path){
		var suppertIcon = "ai,apk,asp,aspx,avo,bmp,catdrawing,catpart,catproduct,cdr,cpp,cs,css,csv,doc,docx,dps,dpt,dwg,eio,eml,et,ett,exb,exe,file,flv,gif,h,html,java,jpeg,jpg,js,jsp,md,mht,mhtl,mhtml,mid,mp3,mp4,mpeg,msi,odp,ods,odt,pdf,png,pps,ppt,pptx,prt,psd,py,rar,rm,rmvb,rtf,sld,sldprt,swf,tif,tiff,txt,url,wav,wma,wmv,wps,wpt,xls,xlsx,zip";
		if(path){
			var icons = suppertIcon.split(",");
			var type = path.substring(path.lastIndexOf(".")+1).toLowerCase();
			for(var i=0;i<icons.length;i++){
				if(icons[i] == type ){
					return "/kabala/images/mobile/"+type+".png";
				}
			}
			return "/kabala/images/mobile/file.png";
		}
		return "/kabala/images/mobile/file.png";
	},

	/**
	 * @Author: WuPeng(2020-06-11 13:14:07)
	 * 获取多少个月前, 支持跨年
	 * time: new Date( )
	 * return yyyyMMddHHmmss
	 */
	getPreMonthDay: function (date, monthNum) {
		let dateArr = $kutil.dateFormat(date, 'yyyy-MM-dd').split('-');
		let year = dateArr[0]   //获取当前日期的年份
		let month = dateArr[1]  //获取当前日期的月份
		let day = dateArr[2]    //获取当前日期的日
		let year2 = year
		let month2 = parseInt(month) - monthNum
		if (month2 <= 0) {
			year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : Math.abs(parseInt(month2 / 12)) + 1);
			month2 = 12 - (Math.abs(month2) % 12);
		}
		let day2 = day
		let days2 = new Date(year2, month2, 0)
		days2 = days2.getDate()
		if (day2 > days2) {
			day2 = days2
		}
		if (month2 < 10) {
			month2 = '0' + month2
		}
		return year2 + month2 + day2 + $kutil.dateFormat(date, 'HHmmss');
	},
	/**
	 * @Author: WuPeng(2020-06-11 13:14:07)
	 * 获取多少个月后, 支持跨年
	 * time: new Date( )
	 * return yyyyMMddHHmmss
	 */
	getNextMonthDay: function(date, monthNum) {
		var dateArr = $kutil.dateFormat(date, 'yyyy-MM-dd').split('-');
		var year = dateArr[0]; //获取当前日期的年份
		var month = dateArr[1]; //获取当前日期的月份
		var day = dateArr[2]; //获取当前日期的日
		var days = new Date(year, month, 0);
		days = days.getDate(); //获取当前日期中的月的天数
		var year2 = year;
		var month2 = parseInt(month) + parseInt(monthNum);
		if (month2 > 12) {
			year2 = parseInt(year2) + parseInt((parseInt(month2) / 12 == 0 ? 1 : parseInt(month2) / 12));
			month2 = parseInt(month2) % 12;
		}
		var day2 = day;
		var days2 = new Date(year2, month2, 0);
		days2 = days2.getDate();
		if (day2 > days2) {
			day2 = days2;
		}
		if (month2 < 10) {
			month2 = '0' + month2;
		}
		return year2 + month2 + day2 + $kutil.dateFormat(date, 'HHmmss');
	},
	 /**
	 * @Author: WuPeng
	 * 转换当前时区日期到UTC日期
	 * !浏览器上的查询时间都需要调用这个函数,否则查询结果时间会有偏移!
	 * time: yyyyMMddHHmmss | new Date( )
	 * return yyyyMMddHHmmss
	 */
	cover2UTCTime: function(time, format){
		//
		let date = undefined;
		if( Object.prototype.toString.call(time) == "[object Date]" ){
			date = time;
		}else{
			let stime = time.toString( );
			let year  = parseInt( stime.substr(0, 4) );
			let month = parseInt( stime.substr(4, 2) ) - 1;
			let day   = parseInt( stime.substr(6, 2) );
			let hh    = parseInt( stime.substr(8, 2) );
			let mm    = parseInt( stime.substr(10, 2) );
			let ss    = parseInt( stime.substr(12, 2) );

			let utclong = Date.UTC(year, month, day, hh, mm, ss, 0);
			date = new Date( utclong + (new Date( ).getTimezoneOffset( ) * 60000) );
		}

		// 格式化时间, 协调世界时 0 时区
		{
			let tf = function(i){return (i < 10 ? '0' : '') + i};
			if(!format){ format = "yyyyMMddHHmmss"; }
			res = format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a){
				switch(a){
				case 'yyyy':
					return tf(date.getUTCFullYear( ));
					break;
				case 'MM':
					return tf(date.getUTCMonth( ) + 1);
					break;
				case 'dd':
					return tf(date.getUTCDate( ));
					break;
				case 'HH':
					return tf(date.getUTCHours( ));
					break;
				case 'mm':
					return tf(date.getUTCMinutes( ));
					break;
				case 'ss':
					return tf(date.getUTCSeconds( ));
					break;
				}
			})
		}
		return res;
	},
	/**
	 * @Author: WuPeng
	 * 转换时间|对象到指定格式
	 * time: yyyyMMddHHmmss | new Date( )
	 * return yyyyMMddHHmmss
	 */
	dateFormat:function(time, format){
		var t = Object.prototype.toString.call(time) == "[object Date]"?time:new Date(parseInt(time+""));
		if(isNaN(t.getTime())){
			return "";
		}
		if(!format){ format = "yyyyMMddHHmmss"; }
		var tf = function(i){return (i < 10 ? '0' : '') + i};
		return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a){
			switch(a){
			case 'yyyy':
				return tf(t.getFullYear( ));
				break;
			case 'MM':
				return tf(t.getMonth( ) + 1);
				break;
			case 'dd':
				return tf(t.getDate( ));
				break;
			case 'HH':
				return tf(t.getHours( ));
				break;
			case 'mm':
				return tf(t.getMinutes( ));
				break;
			case 'ss':
				return tf(t.getSeconds( ));
				break;
			}
		})
	},
	/**
	 * @Author: WuPeng
	 * 加载js和css文件
	 */
	loadsSource: function(src, callback,win){
		var mywin = window;
		if(win){
			mywin=win;
		}
		let head = ""; src = src.split('?')[0];
		let filetype = src.substring(src.lastIndexOf(".") + 1).toLowerCase();
		try { head = mywin.document.getElementsByTagName('head')[0]; }catch (e) {};
		let addobj = {};
		if(filetype == "js"){
			addobj = mywin.document.createElement('script');
		　　addobj.setAttribute("type","text/javascript");
		　　addobj.setAttribute("src", src);
		}else if(filetype == "css"){
		　	addobj = mywin.document.createElement('link');
		　　addobj.setAttribute("rel","stylesheet");
		　　addobj.setAttribute("type","text/css");
		　　addobj.setAttribute("href", src);
		}
		addobj.onload = addobj.onreadystatechange = function() {
			if ((!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
				try {callback();} catch (e) {};
				addobj.onload = addobj.onreadystatechange = null;
				if (head && addobj.parentNode) {
					//head.removeChild(addobj);
				}				
			}
		};
		head.insertBefore( addobj, head.firstChild );
	},
	/**
	 * @Author: WuPeng
	 * 追加CSS
	 */
	appendCSS: function( css ){
		let style = document.createElement("style");
		style.type = "text/css";
		try{ style.appendChild(document.createTextNode(css)); }catch(ex){ style.styleSheet.cssText = css; }
		(document.getElementsByTagName("head")[0]).appendChild(style)
	},
	/**
	 * @Author: WuPeng
	 * 根据路径获取Object值
	 */
	getValueByPath: function (obj, path) {
		if (!obj || !path) {
			return obj;
		}
		let objtemp = obj; let lks = path.split('.');
		for (let i = 0; i < lks.length; i++) {
			if (undefined == objtemp[lks[i]]) { return null; }
			objtemp = objtemp[lks[i]]
		}
		return objtemp;
	},
	// 数字简写
	numberShortConvert: function(num, fiexd, toString){
		let obj = $kutil.unitConvert(num, 10000, undefined == fiexd ? 2 : fiexd, ["", "W"]);
		if(undefined != toString && !toString){
			return obj;
		}
		return obj.num+obj.unit;
	},
	// 文件大小
	fileSizeConvert: function(num, fiexd, toString){
		let obj = $kutil.unitConvert(num, 1024, undefined == fiexd ? 2 : fiexd, ["byte", "KB", "MB", "GB", "TB", "PB"]);
		if(undefined != toString && !toString){
			return obj;
		}
		return obj.num+obj.unit;
	},
	// 数字单位转换
	unitConvert: function(num, span, fiexd, units){
		let _units = units?units.concat([]):[];
		let _span = Number(span);
		let _num = Number(num);
		let m = {num: 0, unit: ""} 
		if(_units.length == 0){
			return m;
		}
		if( !_num || !_span ){
			m.unit = _units[0];
			return m;
		}
		
		let i = Math.floor(Math.log(_num) / Math.log(_span));
		m.num = (_num / Math.pow(_span, i)).toFixed(fiexd);
		m.unit = _units[i];
		return m;
	},
	// 获取整数部分的长度
	strNumSize: function(tempNum){
		let stringNum = tempNum.toString()
		let index = stringNum.indexOf(".")
		let newNum = stringNum;
		if(index!=-1){
			newNum = stringNum.substring(0,index)
		}
		return newNum.length
	},
	// 判断是否是 XX 类型
	isType: function( obj, type ){
		try{
		var testType = Object.prototype.toString.call(obj).slice(8,-1).toLowerCase( );
		return (testType === type.toLowerCase( ));
		}catch( e ){
		return false;
		}
	},
	/**
	 * 拓展|覆盖对象属性
	 * B_IsCopy 指定是否使用拷贝的方式给原有对象添加属性, 默认使用拷贝方式
	 */
	extendAttrs: function( OB_Src, OB_Add, B_IsCopy ){
		if( !OB_Src ){
			return OB_Add;
		}
		if(!$kutil.isType( OB_Src, "object" )){
			OB_Src = {};
		}
		for( var Tx_Key in OB_Add){
			if($kutil.isType( OB_Add[ Tx_Key ], "object" ) && B_IsCopy !== false ){
				OB_Src[ Tx_Key ] = $kutil.extendAttrs(OB_Src[Tx_Key], OB_Add[ Tx_Key ]);
			}else{
				OB_Src[Tx_Key] = OB_Add[ Tx_Key ];
			}
		}
		return OB_Src;
	},
	//删除对象中的空属性
	deleteEmptyProperty: function (object) {
		for (var i in object) {
			var value = object[i];
			if (typeof value === 'object') {
				if (Array.isArray(value)) {
					if (value.length == 0) {
						delete object[i];
						continue;
					}
				}
				$kutil.deleteEmptyProperty(value);
				if ($kutil.isEmpty(value)) {
					delete object[i];
				}
			} else {
				if (value === '' || value === null || value === undefined) {
					delete object[i];
				} else {
				}
			}
		}
	},
	// 判断参数是否为true
	// 数字0为false
	// 数字小等于0为false
	// 无穷为false
	// 空字符串为false
	// 空数组为false
	// 空对象为false
	// 空或undefined为false
	// 字符串'false' 'FALSE' 为false 
	// 其他为true 
	isTrue: function (value, opts) {
		let zero = false, infinity = false, emptyString = false, emptyArray = false, emptyObject = false;

		if(value === 0) return !!zero
		if(value === '') return !!emptyString
		if(value === Infinity) return !!infinity
		if(Array.isArray(value) && value.length === 0) return !!emptyArray
		if(value === null) return false
		if(typeof value === 'object' && Object.keys(value).length === 0) return !!emptyObject
		if(typeof value === 'number' || typeof value === 'string' && !isNaN(parseInt(value)) ) return parseInt(value)>0;
		if(typeof value === 'string') return !(value.toLowerCase()=='false');
		return !!value
	},
	isEmpty: function (object) {
		for (var key in object) {
			return false;
		}
		return true;
	},
	// 数字补零,默认4为
	pad: function (num, n) {
		try{
			if (!n || typeof n !='number') {
				n = 4;
			}
		}catch(e){
			n = 4;
		}
		var len = num.toString().length;
		while(len < n) {
		  num = "0" + num;
		  len++;
		}
		return num;
	},
	// 检查平台
	checkPlatform: function( typeStr ){
		let res = {
		  Win: /Win/i.test(navigator.platform),
		  Mac: /Mac/i.test(navigator.platform),
		  Linux: /Linux/i.test(navigator.platform),
		  iOS: /iOS/i.test(navigator.platform),
		};
		if( typeStr ){
		  return res[ typeStr.toString( ) ];
		}else{
		  return res;
		}
	},
	// 文件、文件夹名称是否包含非法字符
	isValidName: function( nameStr ){
		if(!nameStr || typeof nameStr != 'string' ){
			return false;
		}
		var reg = new RegExp('[\\\\/:*?\"<>|]');
		if (reg.test(nameStr)) {
			return false;
		}
		return true;
	},
	/*** 判断是否为嵌入式浏览器方式 ****/
	checkEmbedBrowser:function(){
		var _browser = $kutil.checkBrowser();
		return _browser.IosApp || _browser.AndroidApp  || _browser.DingTalk  || _browser.WeiXin  || _browser.WeiXinMiniProgram;		
	},
	/**
	 * 判断设备类型 安卓|IOS Web|App
	 * @return {[type]} [description]
	 */
	checkBrowser: function( typeStr ){
		let res = {
			Mobile: false,
			App: false,
			Ios: false,
			Android: false,
			IosApp: false,
			AndroidApp: false,
			Browser: false,
			Client: false,
		};
		try{
			var ua = navigator.userAgent.toLowerCase( );
			// console.log( ua )
			res.Client =  ua.indexOf('kabalaclient') > -1;
			if(!res.Client){
				res.Mobile = ua.indexOf('mobile') > -1;
				res.DingTalk = ua.indexOf('dingtalk') > -1;
				res.Ios = /\b(ipad|iphone|ipod)(?=;)/.test(ua);
				res.Android = ua.indexOf('android') > -1;
				try{
					res.App = ($kmobilebridge||window.$kmobilebridge)?true:false;
					res.IosApp = res.App && res.Ios;
					res.AndroidApp = res.App && res.Android;
					res.Browser = !res.IosApp && !res.AndroidApp;
				}catch(err){}
				res.WeiXin = ua.match(/MicroMessenger/i)=="micromessenger";
				res.WeiXinMiniProgram = res.WeiXin && ua.indexOf('miniprogram') > -1;
			}
		}catch(err){}

		if( typeStr ){
			return res[ typeStr.toString( ) ];
		}else{
			return res;
		}
	},
	// 判断客户端是否支持该功能
	checkClient: function(askop){
		try{
			if(!askop){
				return false;
			}
			askop = askop.toLowerCase();
			var version = $kutil.getClientVersion();
			var bool = false;
			switch (askop) {
				case 'askcopy':
					bool = version >= 20220701;
					break;
				default:
					bool = version > 0;
					 break;
			}
			return bool;
		}catch(e){
			return false;
		}
	},
	// 获取客户端版本
	getClientVersion: function(){
		try{
			var kcl = 'kabalaclient';
			var ua = navigator.userAgent.toLowerCase( );
			if(ua.indexOf(kcl) > -1){
				var list = ua.split(' ');
				var desc = '';
				for(let i=0;i<list.length;i++){
					if( list[i].indexOf(kcl)>-1 ){
						desc = list[i]; break;
					}
				}
				if(desc && desc.indexOf('/')>-1){
					var array = desc.substring(desc.indexOf('/')+1).split('.');
					if(array && array.length==3){
						return parseInt(array[0]+ $kutil.pad(array[1],2)+ $kutil.pad(array[2],2));
					}
				}
			}
			return 0;
		}catch(e){
			return 0;
		}
	},
	// 获取今天凌晨
	getTerdayStart: function( ){
		var date = new Date( );
		date.setHours( 0, 0, 0, 0 );
		return date;
	},
	// 获取昨天日期
	getYesterday: function( ){
		var date = new Date( );
		date.setHours( 0, 0, 0, 0 );
		date.setDate( date.getDate( ) - 1 );
		return date;
	},
	// 获取本周的第一天
	getCurrentWeekFirst: function( ){
		var date = new Date( );
		date.setHours( 0, 0, 0, 0 );
		date.setDate( date.getDate( ) - (date.getDay( )||7)+1 );
		return date;
	},
	// 获取本周的最后一天
	getCurrentWeekLast: function( ){
		var date = new Date( );
		date.setHours( 0, 0, 0, 0 );
		date.setDate( date.getDate( ) - (date.getDay( )||7)+1 );
		date.setDate( date.getDate( )+6 );
		return date;
	},
	// 获取当前月的第一天
	getCurrentMonthFirst: function( ){
		var date = new Date( );
		date.setDate(1);
		date.setHours(0, 0, 0, 0);
		return date;
	},
	// 获取当前月的最后一天
	getCurrentMonthLast: function( ){
		var date = new Date( );
		date.setMonth( date.getMonth( ) + 1 );
		date.setDate(0);
		date.setHours(23, 59, 59, 0);
		return date;
	},
	// 获取上个月的第一天
	getAfterMonthFirst: function( ){
		var date = new Date( );
		date.setMonth( date.getMonth( ) - 1 );
		date.setDate(1);
		date.setHours(0, 0, 0, 0);
		return date;
	},
	// 获取上个月的最后一天
	getAfterMonthLast: function( ){
		var date = new Date( );
		date.setDate(0);
		date.setHours(23, 59, 59, 0);
		return date;
	},
	// 获取前30日
	getthryday: function( ){
		var date = new Date( );
		date.setHours( 0, 0, 0, 0 );
		date.setDate( date.getDate( ) - 30 );
		return date;
	},
	// 获取前7日
	getsevday: function( ){
		var date = new Date( );
		date.setHours( 0, 0, 0, 0 );
		date.setDate( date.getDate( ) - 7 );
		return date;
	},
	//获取n月后日期
	getmonthlater: function( n ){
		n = parseInt(n);
		if (isNaN(n)) { n = 0;}
		var date = new Date();
		date.setHours( 0, 0, 0, 0 );
		date.setMonth(date.getMonth() + n);
		return date;
	},
	// 获取最近多少天的时间列表
	getRecentDateList: function( count, format ){
		var result = [];
		if( count ){
			for (var i = 0; i < count; i++) {
				let date = new Date( );
				date.setDate(date.getDate( ) - i);
				date.setHours(0, 0, 0, 0);
				result.push( $kutil.dateFormat(date, format) );
			}
		}
		return result;
	},
	// 格式化mb大小
	formatMbSize:function(filesize){
		if(!filesize){
			return "0 M";
		}
		return $kutil.formatSize(parseInt(filesize+"")*1024*1024);
	},
	formatSize:function(fileSize){
		try{
			if(fileSize==0){
				return "0 KB";
			}
			if(fileSize < 1024){
				return fileSize+" byte";
			}else if (fileSize<(1024*1024)) {
				var temp = fileSize / 1024;
				temp = temp.toFixed(0);
				return temp + ' KB';
			}else if (fileSize<(1024*1024*1024)) {
				var temp = fileSize / (1024*1024);
				if(temp.toFixed(1).endWith(".0")){
					return temp.toFixed(0)+ ' MB';
				}else{
					return temp.toFixed(2) + ' MB';
				}
			}else if( fileSize<(1024*1024*1024*1024) ){
				var temp = fileSize / (1024*1024*1024);
				if(temp.toFixed(2).endWith(".00")){
					return temp.toFixed(0)+ ' GB';
				}else{
					return temp.toFixed(2) + ' GB';
				}
			}else{
				var temp = fileSize / (1024*1024*1024*1024);
				if(temp.toFixed(3).endWith(".000")){
					return temp.toFixed(0)+ ' TB';
				}else{
					return temp.toFixed(3) + ' TB';
				}
			}
		}catch(e){
			return filesize;
		}
	},

	formatSize2:function(fileSize){
		try{
			if(fileSize==0){
				return "0";
			}
			if(fileSize < 1024){
				return fileSize;
			}else if (fileSize<(1024*1024)) {
				var temp = fileSize / 1024;
				temp = temp.toFixed(0);
				return temp ;
			}else if (fileSize<(1024*1024*1024)) {
				var temp = fileSize / (1024*1024);
				if(temp.toFixed(1).endWith(".0")){
					return temp.toFixed(0);
				}else{
					return temp.toFixed(2);
				}
			}else if( fileSize<(1024*1024*1024*1024) ){
				var temp = fileSize / (1024*1024*1024);
				if(temp.toFixed(2).endWith(".00")){
					return temp.toFixed(0);
				}else{
					return temp.toFixed(2);
				}
			}else{
				var temp = fileSize / (1024*1024*1024*1024);
				if(temp.toFixed(3).endWith(".000")){
					return temp.toFixed(0);
				}else{
					return temp.toFixed(3);
				}
			}
		}catch(e){
			return filesize;
		}
	},
	ss2time: function( ss ){ //秒转时分秒 HH:mm:ss
		var hh=mm=0;
		var ss = ~~ss;// 秒
		if(ss>3599){
			hh=Math.floor(ss/3600);
			mm=Math.floor(ss%3600/60);
			ss=ss%60;
			return (hh>9?hh: hh)+":"+(mm>9?mm: "0"+mm)+":"+(ss>9?ss: "0"+ss);
		}else if(ss>59){
			mm=Math.floor(ss/60);
			ss=ss%60;
			return "00:"+(mm>9?mm: "0"+mm)+":"+(ss>9?ss: "0"+ss);
		}else{
			return "00:00:"+(ss>9?ss: "0"+ss);
		}
	},
	ss2timestr: function( ss ){ //秒转时分秒
		var hh=mm=0;
		var ss = ~~ss;// 秒
		if(ss>3599){
			hh=Math.floor(ss/3600);
			mm=Math.floor(ss%3600/60);
			ss=ss%60;
			return (hh>9?hh: hh)+"小时"+(mm>9?mm: mm)+"分"+(ss>9?ss: ss)+'秒';
		}else if(ss>59){
			mm=Math.floor(ss/60);
			ss=ss%60;
			return (mm>9?mm: mm)+"分"+(ss>9?ss: ss)+'秒';
		}else{
			return (ss>9?ss: ss)+'秒';
		}
	},
	date2time:function(date,timezone){
		var timenum = moment(date).format('YYYYMMDDHHmmss');
		return $kutil.formatTime(timenum,timezone);
	},
	formatDateObject:function (timenum, timezone){
		if(timenum<0){
			return "";
		}
		if(typeof(timezone)=='undefined'){
			try{
				timezone = parseInt($khttp.session().timezone);
				if(isNaN(timezone)){
					timezone=8;
				}
			}catch(e){
				timezone=8;
			}
		}
		var stime = timenum+'';
		var year = stime.substr(0, 4);
		var month = stime.substr(4, 2);
		var day = stime.substr(6, 2);
		var hh = stime.substr(8, 2);
		var mm = stime.substr(10, 2);
		var ss = stime.substr(12, 2);
		
		var utcLongTime = Date.UTC(parseInt(year), parseInt(month)-1, parseInt(day), parseInt(hh), parseInt(mm), parseInt(ss), 0);
		var d = new Date(utcLongTime);
		var localTime = d.getTime();
		var localOffset = d.getTimezoneOffset() * 60000; /*** 返回格林威治时间和本地时间之间的时差，以分钟为单位。 ***/
		var utc = localTime + localOffset;
		var calctime = utc + (3600000*timezone); 
		return new Date(calctime); 		
	},
	formatTime:function(timenum,timezone,format){
		if(timenum==undefined || timenum<0){
			return "";
		}		
		var mydate = $kutil.formatDateObject(timenum, timezone);
		if(isNaN(mydate.getTime())){
			return "";
		}
		return moment(mydate).format(format || "YYYY-MM-DD HH:mm");
	},	
	formatRelativeTime:function (timenum, timezone) {		
		if(timenum<0){
			return "";
		}
		var mydate = $kutil.formatDateObject(timenum,timezone);//GMT+0时间
		if(isNaN(mydate.getTime())){
			return "";
		}
		var text = moment(mydate).format('YYYYMMDDHHmmss');
		//moment 是客户端时间...
		return moment(text, "YYYYMMDDhhmmss").fromNow();
	},
	toPercent:function(num1,num2){
		return num1<=0 || num2<=0 ? 0 : (Math.round(num2 / num1 * 100));
	},
	//类型检查
	isArray:function(o){
		if(o==undefined){
			return false;
		}
		return Object.prototype.toString.call(o)=='[object Array]';
	},
	isString:function(o){
		if(o==undefined){
			return false;
		}
		return (typeof o)=="string";
	},
	setCookie:function (cname, cvalue, exdays) {
		var expires ="";
		if(exdays!=undefined && exdays>0){
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString() + ";";
		}
		//$cookie.set("access","1");
		document.cookie = cname + "=" + cvalue + ";path=/;" + expires;
	},
	getCookie:function (cname) {
		// (^| )userid=([^;]*)(;|$)
		var arr, reg = new RegExp("(^| )" + cname + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg))
			return (arr[2]);
		else
			return null;
	},
	addEvent:function(obj,EventName,callBack){
		//给对象添加事件
		if(obj.addEventListener){   //FF
			obj.addEventListener(EventName,callBack,false);
		}else if(obj.attachEvent){//IE
			obj.attachEvent('on'+EventName,callBack);
		}else{
			obj["on"+EventName]=callBack;
		}
	},
	isHTMLCollection:function(o){
		if(o==undefined){
			return false;
		}
		if(o.length==undefined){
			return false;
		}
		var type = o.toString();
		return type.startWith('[') && type.endWith(']');
	},
	dom:function(vue,ref){
		if(vue==undefined){
			return null;
		}
		if((typeof vue) == "string" ){
			return document.getElementById(vue);
		}
		return vue.$refs[ref].$el;
	},
	hide:function(obj){
		if(obj==null || obj==undefined){return;}
		if($kutil.isHTMLCollection(obj)){
			for(var node in obj){
				node.style.display='none';
			}
		}else{
			obj.style.display='none';
		}
	},
	show:function(obj){
		if(obj==null || obj==undefined){return;}
		if($kutil.isHTMLCollection(obj)){
			for(var node in obj){
				node.style.display='';
			}
		}else{
			obj.style.display='';
		}
	},
	hasClass:function(obj, cls) {
		if(obj==null || obj==undefined || $kutil.isString(obj)){return false;}
		return obj.className!=undefined && obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
	},
	addClass:function(obj, cls) {

		if(obj==null || obj==undefined ){return;}
		if($kutil.isHTMLCollection(obj)){
			if(obj.length<=0){
				return
			};
			for(var i =0;i<obj.length;i++){
				var node = obj.item(i);
				if (!$kutil.hasClass(node, cls)) {
					node.className += " " + cls;
				}
			}

		}else{
			if (!$kutil.hasClass(obj, cls)){
				obj.className += " " + cls;
			}
		}
	},
	removeClass:function(obj, cls) {
		if(obj==null || obj==undefined){
			return;
		}
		if($kutil.isHTMLCollection(obj)){
			if(obj.length<=0){
				return;
			};
			for(var i =0;i<obj.length;i++){
				var node = obj.item(i);
				if ($kutil.hasClass(node, cls)) {
					var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
					node.className = node.className.replace(reg, '');
				}
			}
		}else{
			if ($kutil.hasClass(obj, cls)) {
				var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
				obj.className = obj.className.replace(reg, ' ');
			}
		}

	},
	toggleClass:function(obj,cls){
		if(obj==null || obj==undefined){return;}
		if($kutil.isHTMLCollection(obj)){
			if(obj.length<=0){return};
			for(var i =0;i<obj.length;i++){
				var node = obj.item(i);
				if ($kutil.hasClass(node, cls)) {
					removeClass(node, cls);
				}else{
					addClass(node, cls);
				}
			}
		}else{
			if($kutil.hasClass(obj,cls)){
				removeClass(obj, cls);
			}else{
				addClass(obj, cls);
			}
		}
	},
	/***** APP/SPACE相关 *****/

	getspacebytype:function(spacetype){
		if(spacetype==undefined || spacetype==null){
			return {};
		}
		var spaces = $khttp.session().spaces;
		if(!spaces){
			return {};
		}

		for(var i=0;i<spaces.length;i++){
			if(spaces[i].spacetype == spacetype ){
				return spaces[i];
			}
		}
		return {};
	},
	getspace:function(spacepath){
		if(spacepath==undefined || spacepath==null){
			return {};
		}
		var spaces = $khttp.session().spaces;
		if(!spaces){
			return {};
		}
		for(var i=0;i<spaces.length;i++){			
			if(spacepath.startWith("@"+spaces[i].spaceid+"/") || spacepath==("@"+spaces[i].spaceid)){
				return spaces[i];
			}
		}
		return {};
	},
	getspacename:function(spacepath){
		try{
			var space = $kutil.getspace(spacepath);
			return space.spacename;
		}catch(e){
			return "";
		}
	},
	getspaceroot:function(spacepath){
		try{
			var space = $kutil.getspace(spacepath);
			return space.spaceroot;
		}catch(e){
			return "";
		}
	},
	getspaceapiurl:function(spacepath){
		try{
			var space = $kutil.getspace(spacepath);
			return space.spaceapi;
		}catch(e){
			return "";
		}
	},
	parsespacepath:function(spacepath){
		try{
			var space = $kutil.getspace(spacepath);
			return spacepath.replace(space.spaceroot, space.spacename);
		}catch(e){
			return spacepath;
		}
	},
	parseshowpath:function(spacepath,showpath,space){
		try{
			if(!space){
				var space = $kutil.getspace(spacepath);
			}
			let prefix = showpath && showpath.startWith('#')?'#':'/';
			let path = showpath.replace( prefix+space.spacename, "@"+space.spaceid);
			if( path.startWith(space.spaceroot) ){
				path =  path.replace(space.spaceroot, space.spacename);
			}else{
				path =  path.replace( "@"+space.spaceid, space.spacename);
			}
			return path;
		}catch(e){
			return showpath?showpath:(spacepath?spacepath:'');
		}
	},
	
	parsecustompath:function(custompath){
		try{
			if(custompath == undefined || custompath == null){
				return "";
			}
			var spaceroot = "";
			var spaces = $khttp.session().spaces;
			if(spaces){
				for(var i = 0; i < spaces.length; i++){
					var space = spaces[i];
					if(custompath.startWith(space.spacename)){
						spaceroot = space.spaceroot;
						break;
					}
				}
			}
        	var index1 = custompath.indexOf("/");
        	if(index1 > 0){
        		custompath = spaceroot + custompath.substring(index1, custompath.length + 1);
        	}else{
        		custompath = custompath.replace(space.spacename, spaceroot);
        	}
			return custompath;
		}catch(e){
			return "";
		}
	},
	
	getnodeshowurl: function(node){
		try {
			if(node){
				if(node.showurl){
					return node.showurl;
				}else if(node.path){
					return '/pan/viewprop.html?path='+ encodeURIComponent(node.path);
				}
				return '';
			}
			return '';	
		} catch (e) {
			return '';	
		}
	},
	// 防抖 一段时间内只执行最后一次
	debounce: function(){
		let timer = null;
		return function(callback, wait) {
			let t = wait || 500;
			timer && clearTimeout(timer);
			timer = setTimeout(callback, t);
		}
	}(),
	// 节流 每隔一段时间执行一次
	throttle:function(){
		let last = 0
		return function(callback, wait) {
			let now = +new Date()
			let t = wait || 500;
			if (now - last > t) {
				callback()
				last = now
			}
		}
	}(),
	// 格式化游览数量 超过1w 取小数点后一位，超过10w 显示10w+
	formatViewCount:function(num){
		let ret = num + "";
		// var ones  = parseInt(num % 10); // 个位数
		// var tens  = parseInt((num % 100) / 10);  // 十位数
		// var hundreds  = parseInt((num % 1000) / 100); // 百位数
		var thousands = parseInt((num % 10000) / 1000); // 千位数
		var myriabit = parseInt((num % 100000) / 10000); // 万位数
		var tensMyriabit = parseInt((num % 1000000) / 100000); // 十万位数
		if(myriabit){
			ret = myriabit + "." + thousands + "w";
		}
		if(tensMyriabit){
			ret = "10w+";
		}
		return ret;
	}
}

module.exports = $kutil;
